import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact">
      <div className="container">
        <h2>Contact Us</h2>
        <div className="contact-container">
          <div className="book-meeting-section">
            <h3>Schedule a Meeting</h3>
            <p>Want to discuss your project in detail? Schedule a meeting with us at your convenience.</p>
            <a 
              href="https://calendly.com/saurabh-gotuna"
              target="_blank"
              rel="noopener noreferrer"
              className="calendly-button"
            >
              Schedule a Meeting
            </a>
          </div>

          <div className="contact-form-section">
            <h3>Send us a Message</h3>
            <p>Have questions about our services? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 